(function(root){
  'use strict';
  const WAIT=5000, DURATION=600000;
  const create=now=>({queuedAt:now,readyAt:now+WAIT,expiresAt:now+WAIT+DURATION});
  const valid=s=>!!s && [s.queuedAt,s.readyAt,s.expiresAt].every(Number.isFinite) && s.readyAt-s.queuedAt===WAIT && s.expiresAt-s.readyAt===DURATION;
  function state(s,now){
    if(!valid(s))throw new Error('Invalid booking session');
    const wait=Math.max(0,s.readyAt-now),remaining=Math.max(0,s.expiresAt-now);
    return {phase:wait>0?'waiting':remaining>0?'active':'expired',waitSeconds:Math.ceil(wait/1000),people:Math.ceil(Math.min(WAIT,wait)/WAIT*24),progress:Math.max(0,Math.min(1,1-wait/WAIT)),remainingSeconds:Math.ceil(Math.min(DURATION,remaining)/1000)};
  }
  const api={WAIT,DURATION,create,valid,state};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else root.P1SessionClock=api;
})(typeof window!=='undefined'?window:globalThis);
